import { render, staticRenderFns } from "./WarnDetail.vue?vue&type=template&id=53de8ec6&scoped=true&"
import script from "./WarnDetail.vue?vue&type=script&lang=ts&"
export * from "./WarnDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53de8ec6",
  null
  
)

export default component.exports